import { isFiniteNumber } from '@federa/const/number-guards';

/** Coerce a value to the number it spells or to its trimmed string, else undefined: a finite number passes through; a
 * string that round-trips through `Number.parseFloat` EXACTLY (`String(numeric) === trimmed`) becomes that number, so
 * `'007'` and `'1.0'` stay strings; a blank string and every other type are undefined. */
export function coerceStringOrNumber(value: unknown): string | number | undefined {
	if (isFiniteNumber(value)) {
		return value;
	}
	if (typeof value === 'string') {
		const trimmed = value.trim();
		if (!trimmed) return undefined;
		const numeric = Number.parseFloat(trimmed);
		if (!Number.isNaN(numeric) && String(numeric) === trimmed) {
			return numeric;
		}
		return trimmed;
	}
	return undefined;
}
